export const DEFAULT_LOGO =
  "https://s3.amazonaws.com/dev-etr/images/defaults/ETR%2BLogo.png"
export const MODELS_ICON =
  "https://s3.amazonaws.com/dev-etr/images/3d-modeling.svg"
export const DATA_ICON = "https://s3.amazonaws.com/dev-etr/images/research.svg"
export const ANALYSES_ICON =
  "https://s3.amazonaws.com/dev-etr/images/analysis.svg"
export const VENN_LOGO =
  "https://s3.amazonaws.com/dev-etr/images/defaults/VENN+Logo.svg"

export const EMAIL_REGEX = /^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$/

export const TOPIC_TYPE = {
  VENDOR: "vendor",
  SECTOR: "sector",
  QUICK_TAKES: "quick takes",
  WEBINAR: "webinar",
}

export const SHARED_INSIGHTS_REPORT_TYPE = {
  VendorFocus: {
    displayName: "Vendor Focus",
    defaultImage: "/static/images/vendor-focus-fallback.svg",
  },
  IndustryAnalysis: {
    displayName: "Industry Analysis",
    defaultImage: "/static/images/industry-analysis-fallback.svg",
  },
  ObservatoryReport: {
    displayName: "Observatory Report",
    defaultImage: "/static/images/observatory-fallback.png",
  },
}
